import { useParams } from "react-router-dom";
import { useLiveQuery } from "@/core/hooks/useLiveQuery";
import { PageLayout } from "@/components/templates/page-layout";
import { ZoneForm } from "@/components/organisms/zone-form";
import { useZones } from "@/core/hooks/useZones";
import { offlineDb } from "@/core/offline/db";

export default function ModifierZonePage() {
  const { siteId, zoneId } = useParams<{ siteId: string; zoneId: string }>();
  const { updateZone } = useZones(siteId!);
  const zone = useLiveQuery(() => offlineDb.zones.get(zoneId!), [zoneId]);

  // Compter les pins pour bloquer l'édition du plan si des pins existent (modèle B)
  const pinCount = useLiveQuery(
    () => offlineDb.pins.where("zoneId").equals(zoneId!).count(),
    [zoneId]
  ) ?? 0;

  if (!zone) {
    return (
      <PageLayout title="Modifier la zone">
        <p className="text-muted-foreground">Zone introuvable.</p>
      </PageLayout>
    );
  }

  return (
    <PageLayout title="Modifier la zone">
      <ZoneForm
        defaultValues={{ name: zone.name }}
        existingPlanBlob={zone.planBlob}
        planLocked={pinCount > 0}
        onSubmit={async (data) => {
          await updateZone(zoneId!, {
            name: data.name,
            planBlob: data.planBlob,
            planType: data.planType ?? zone.planType,
          });
        }}
      />
    </PageLayout>
  );
}
